import { nanoid } from 'nanoid';
import { getUserId } from '../storage';
import { enqueue } from '../core/perspective-tracking-api';

// Types
import type { NormalizedData } from '$lib/types/NormalizedData';

export const track = (event: string, data: any) => {
    const normalizedData = normalizeData('track', data);
    normalizedData.event = event;

    return enqueue('/t', normalizedData);
};

export const page = (pageName: string, data: any) => {
    const normalizedData = normalizeData('page', data);
    normalizedData.name = pageName;

    return enqueue('/p', normalizedData);
};

export const normalizeData = (type: string, data: any): NormalizedData => {
    return {
        timestamp: new Date().toISOString(),
        sentAt: new Date().toISOString(),
        context: {
            page: {
                path: window.location.pathname,
                referrer: document.referrer,
                search: window.location.search,
                title: document.title,
                url: window.location.href,
            },
            userAgent: window.navigator.userAgent,
            locale: window.navigator.language,
        },
        properties: data,
        messageId: `perspective-${nanoid()}`,
        type: type,
        anonymousId: getUserId(),
    };
};

export default {
    track,
    page,
};
